import React from "react";

import Select from "react-select";

import {ILabel, Label} from "./Label";



export const SelectLabeled: React.FC<Props> = (props: Props): JSX.Element => {

    const placeHolder = props.placeHolder ? props.placeHolder : "";
    const onClear = props.onClear ? props.onClear.bind(this) : props.onClear

    return (
        <div className="input-container">
            {props.label === undefined ?
                null :
                <Label
                    label={props.label}
                    isRequired={props.isRequired}
                />
            }
            <Select
                value={props.value}
                styles={customStyles}
                isClearable={onClear}
                className={'react-select-container'}
                classNamePrefix="react-select"
                isSearchable={props.isSearchable}
                placeholder={placeHolder}
                onChange={props.onChange}
                options={props.options}
            />
        </div>
    ) }

const customStyles = {
    menu: (provided : any) => ({
        ...provided,
        width: 300
    })
};

interface Props {
    readonly onChange : React.ChangeEventHandler;
    readonly onClear : React.ChangeEventHandler | undefined;
    readonly value : Array<FieldValue>;
    readonly options : Array<FieldValue>;
    readonly label : ILabel | undefined;
    readonly isRequired : boolean | undefined;
    readonly isSearchable : boolean | undefined;
    readonly placeHolder : string | undefined;
}

interface FieldValue {
    readonly value : string;
    readonly label : string;

}